import "./Zero_touch_section.css";
import whatsapp_icon from "../../Img/Android_Enterprise_image/whatsapp_icon.png";
import mail_icon from "../../Img/Android_Enterprise_image/mail_icon.png";
import assign_devices from "../../Img/Zero_touch_image/assign_devices.svg";
import configure_policies from "../../Img/Zero_touch_image/configure_policies.svg";
import get_going from "../../Img/Zero_touch_image/get_going.svg";
import demo from "../../Img/Zero_touch_image/demo.png";
import { Link } from "react-router-dom";

import Navbar from "../../Components/Navbar/Navbar";
import Footer from "../../Components/Footer/Footer";
const zero_touch_section = () => {
  return (
    <>
      <Navbar />
      <section class="py-0">
        <div class="swiper theme-slider min-vh-100">
          <div class="swiper-wrapper">
            <div class="bg-hold"></div>
            {/* ---/.bg-holder--- */}
            <div class="container">
              <div class="row min-vh-100 py-8 align-items-center">
                <div
                  class="col-sm-8 col-lg-7 px-5 px-sm-3"
                  //  style={ "z-index: 10;"}s
                >
                  <div class="">
                    <h1 class="neon">
                      Android Zero-touch Enrollment With Harsafe
                    </h1>
                  </div>
                  <div class="">
                    <p class="pt-4 mb-5 fs-1 fs-md-2 lh-xs st-sub-titl">
                      Easy, secure, quick enrollment and deployment of
                      corporate-owned Android devices in bulk for a streamlined
                      process and improved enterprise management.
                    </p>
                  </div>

                  <div class="dropdown-str">
                    <Link
                      to="/ContactUs"
                      className="dropbtn-str"
                      target="blank"
                    >
                      Contact Us
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ------------------------------------------------------ */}
      <section class="bg-white text-center">
        <div class="container">
          <div class="row justify-content-center text-center azth">
            <div class="col-10 col-md-12">
              <h2 class="fs-4 fs-lg-3">Welcome to the Elixir</h2>
              <p class="px-lg-4">
                Get expert consultancy and support with Elixir, an advisory firm
                that stand by your side always.
              </p>
              <hr class="short" />
            </div>
          </div>
          <div class="row mt-4 mt-md-5">
            <div class="col-sm-6 col-lg-3 mt-4">
              <div class="card">
                <div class="ring-icon mx-auto mt-4 mb-2">
                  <img
                    style={{
                      width: "410px",
                    }}
                    src={assign_devices}
                    alt=""
                  />
                </div>
                <h5 class="mt-4">Assign Devices</h5>
                <p class="mb-0 mt-3 px-3 mb-4">
                  Seamlessly enroll devices with Android Zero-touch, ensuring
                  secure, automated deployment. Welcome to the Elixir of
                  hassle-free device management with Soumya IT Solution.
                </p>
              </div>
            </div>

            <div class="col-sm-6 col-lg-3 mt-4">
              <div class="card">
                <div class="ring-icon mx-auto mt-4 mb-2">
                  <img
                    style={{
                      width: "410px",
                    }}
                    src={configure_policies}
                    alt=""
                  />
                </div>
                <h5 class="mt-4">Configure Policies</h5>
                <p class="mb-0 mt-3 px-3 mb-4">
                  Configure policies effortlessly to enforce security,
                  compliance, and user access controls, ensuring a seamless and
                  protected device management experience.
                </p>
              </div>
            </div>

            <div class="col-sm-6 col-lg-3 mt-4">
              <div class="card">
                <div class="ring-icon mx-auto mt-4 mb-2">
                  <img
                    style={{
                      width: "410px",
                    }}
                    src={get_going}
                    alt=""
                  />
                </div>
                <h5 class="mt-4">Get Going</h5>
                <p class="mb-0 mt-3 px-3 mb-4">
                  Get going with seamless integration, automated setups, and
                  user-friendly controls for a smooth and efficient experience.
                </p>
              </div>
            </div>

            <div class="col-sm-6 col-lg-3 mt-4">
              <div class="card">
                <div class="ring-icon mx-auto mt-4 mb-2">
                  <img
                    style={{
                      width: "410px",
                    }}
                    src={assign_devices}
                    alt=""
                  />
                </div>
                <h5 class="mt-4">Assign Devices</h5>
                <p class="mb-0 mt-3 px-3 mb-4">
                  Zero-touch Enrollment allows IT admin to assign the devices
                  from the Scalefusion dashboard.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* --------------------------------------------------------- */}
      <section class="bg-100">
        <div class="container">
          <div class="col-10 m-auto">
            <div class="text-center mb-6 azth">
              <h2 class="fs-4 fs-md-3">Our Services</h2>
              <hr class="short" />
            </div>
            <div class="row g-0 position-relative mb-4 mb-lg-0">
              <div class="st-circle-ripplee1"></div>
              <div class="col-lg-4 py-3 py-lg-0 mb-0 position-relative new-st-heo">
                <div class="bg-holder rounded-ts-lg rounded-te-lg rounded-lg-te-0 ">
                  <img
                    src={demo}
                    alt="Image"
                    className="img-anim-zt bounce-5"
                  />
                </div>
              </div>
              <div class="col-lg-8 px-lg-5 py-lg-6 p-4 my-lg-0 bg-white rounded-bs-lg rounded-lg-bs-0 rounded-be-lg rounded-lg-be-0 rounded-lg-te-lg ">
                <div class="elixir-caret d-none d-lg-block"></div>

                <div class="azth">
                  <div class="overflow-hidden">
                    <h5 class="fs-2 fs-md-1">
                      Streamline Device Provisioning With Zero-touch Enrollment
                    </h5>
                  </div>
                  <div class="overflow-hidden">
                    <p class="mt-3">
                      As one of the world’s largest accountancy networks, elixir
                      helps a diverse range of clients with a diverse range of
                      needs.This is especially true of our Advisory Practice,
                      which provides corporate finance and transaction services,
                      business restructuring.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="row g-0 position-relative mb-4 mb-lg-0">
              <div class="st-circle-ripplee2"></div>
              <div class="col-lg-4 py-3 py-lg-0 mb-0 position-relative order-lg-2 new-st-heo">
                <div class="bg-holder rounded-ts-lg rounded-te-lg rounded-lg-te-0 ">
                  <img
                    src={demo}
                    alt="Image"
                    className="img-anim-zt bounce-5"
                  />
                </div>
              </div>
              <div class="col-lg-8 px-lg-5 py-lg-6 p-4 my-lg-0 bg-white rounded-bs-lg rounded-lg-bs-0 rounded-be-lg rounded-lg-be-0 rounded-lg-te-lg ">
                <div class="elixir-caret d-none d-lg-block"></div>

                <div class="azth">
                  <div class="overflow-hidden">
                    <h5 class="fs-2 fs-md-1">
                      Configure Zero-touch Enrollment From Our Web-Based
                      Dashboard
                    </h5>
                  </div>
                  <div class="overflow-hidden">
                    <p class="mt-3">
                      Elixir serves clients across the country and around the
                      world as they navigate an increasingly complex tax
                      landscape. Our tax professionals draw on deep experience
                      and industry-specific knowledge to deliver clients the
                      insights and innovation they need.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="row g-0 position-relative mb-4 mb-lg-0">
              <div class="st-circle-ripplee1"></div>
              <div class="col-lg-4 py-3 py-lg-0 mb-0 position-relative new-st-heo">
                <div class="bg-holder rounded-ts-lg rounded-te-lg rounded-lg-te-0 ">
                  <img
                    src={demo}
                    alt="Image"
                    className="img-anim-zt bounce-5"
                  />
                </div>
              </div>
              <div class="col-lg-8 px-lg-5 py-lg-6 p-4 my-lg-0 bg-white rounded-bs-lg rounded-lg-bs-0 rounded-be-lg rounded-lg-be-0 rounded-lg-te-lg ">
                <div class="elixir-caret d-none d-lg-block"></div>

                <div class="azth">
                  <div class="overflow-hidden">
                    <h5 class="fs-2 fs-md-1">Advisory</h5>
                  </div>
                  <div class="overflow-hidden">
                    <p class="mt-3">
                      To help you understand what this road looks like, we
                      surveyed 1165 digital marketers across Europe and North
                      America to explore current trends and priorities in
                      digital marketing.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ----------------------------------------------------------------- */}
      <Footer />
    </>
  );
};

export default zero_touch_section;
